const en = {
  // Navbar
  nav: {
    services: "Services",
    projects: "Projects",
    about: "About",
    contact: "Contact",
    getInTouch: "Get in Touch",
  },
  
  // Hero
  hero: {
    badge: "BMS",
    title1: "The Next Level",
    title2: "of Intelligence",
    subtitle: "Smart systems, real solutions.",
    cta1: "Start Project",
    cta2: "Who We Are?",
    scroll: "Explore",
  },
  
  // Brand Statements
  brand: {
    s1: "Intelligence-driven architecture",
    s2: "Enterprise-grade systems",
    s3: "Security & performance first",
    s4: "Future-ready software",
  },
  
  // Services
  services: {
    title: "Our Services",
    subtitle: "High-performance solutions tailored to your needs",
    detailBtn: "Learn More",
    allServices: "All Services",
  },
  
  // Process
  process: {
    title: "How We",
    titleHighlight: "Work?",
    subtitle: "Our proven process for successful projects",
    steps: [
      { number: "01", title: "Analysis & Discovery", desc: "We deeply understand your needs" },
      { number: "02", title: "Architecture Design", desc: "We build scalable system architecture" },
      { number: "03", title: "Development", desc: "We code with agile methodology" },
      { number: "04", title: "Testing & Security", desc: "Comprehensive testing and security audit" },
      { number: "05", title: "Go Live", desc: "Seamless deployment process" },
      { number: "06", title: "Continuous Support", desc: "24/7 technical support and maintenance" },
    ],
  },
  
  // Why BMS
  why: {
    title: "Why",
    titleHighlight: "BrightMind Software?",
    subtitle: "We don't just develop software. We build systems that carry your business into the future.",
    reasons: [
      "We don't write code, we build systems.",
      "Not ready-made solutions, the right architecture.",
      "Your long-term technology partner.",
      "Performance, security, sustainability.",
    ],
  },
  
  // Tech Stack
  tech: {
    title: "Technology Stack",
    subtitle: "Future-ready systems with modern technologies",
  },
  
  // Projects
  projects: {
    title: "Our Projects",
    subtitle: "Examples from our successfully completed projects",
    viewDetails: "View Details",
    noProjects: "No projects added yet.",
    allProjects: "All Projects",
    comingSoonTitle: "Exciting Projects Coming Soon!",
    comingSoonMessage: "Our team is currently working on innovative projects. We'll share our newest and most impressive work here with you.",
    comingSoonBadge: "Actively in development",
    contactUs: "Let's Discuss Your Project",
  },
  
  // CTA
  cta: {
    title1: "If you have an idea,",
    title2: "we transform it into a powerful system.",
    subtitle: "We're ready to discuss your dream project. Let's build powerful systems together.",
    btn1: "Discuss Your Project",
    btn2: "Get in Touch",
  },
  
  // Footer
  footer: {
    company: "BrightMind Software",
    rights: "© 2024 BrightMind Software. All rights reserved.",
    tagline: "BrightMind Software – The Next Level of Intelligence",
  },
  
  // Pages
  pages: {
    backToHome: "Back to Home",
    loading: "Loading...",
  },
  
  // Contact Form
  contact: {
    name: "Your Name",
    email: "Email",
    message: "Your Message",
    send: "Send",
    success: "Your message has been sent successfully!",
  },
};

export default en;
